<script>
  import { StaticMenu } from "@obamafoundation/of-design-system";

  export let data;
</script>

<h1 class="heading-md">OPC Web Utilities</h1>

<div class="py-7.5 lg:py-15 w-full lg:w-2/3 xl:1/2">
  <StaticMenu
    links={data.staticRoutes.map((route) => ({
      url: route,
      label: route
    }))}
  />
</div>
